module.exports = __webpack_public_path__ + "static/media/gold.ad266f74.png";